module.exports = __webpack_public_path__ + "img/pie-chart.81cab3e1.svg";